module.exports = __webpack_public_path__ + "img/greenwich-g-series-front-angle.1e36921f.png";